// export const skillsData = [
//   {
//     label: "Front End",
//     data: [
//       {
//         skillName: "HTML",
//         percentage: "90",
//       },
//       {
//         skillName: "CSS",
//         percentage: "50",
//       },
//       {
//         skillName: "JavaScript",
//         percentage: "80",
//       },
//       {
//         skillName: "React",
//         percentage: "75",
//       },
//       {
//         skillName: "Angular",
//         percentage: "60",
//       },
//       {
//         skillName: "Vue.js",
//         percentage: "70",
//       },
//       {
//         skillName: "Bootstrap",
//         percentage: "85",
//       },
//       {
//         skillName: "Sass",
//         percentage: "65",
//       },
//       {
//         skillName: "TypeScript",
//         percentage: "70",
//       },
//       {
//         skillName: "Git",
//         percentage: "80",
//       },
//     ],
//   },
//   {
//     label: "Data Science & Machine Learning",
//     data: [
//       {
//         skillName: "Python",
//         percentage: "85",
//       },
//       // {
//       //   skillName: "R",
//       //   percentage: "70",
//       // },
//       {
//         skillName: "SQL",
//         percentage: "75",
//       },
//       {
//         skillName: "Pandas",
//         percentage: "80",
//       },
//       {
//         skillName: "NumPy",
//         percentage: "75",
//       },
//       {
//         skillName: "Scikit-Learn",
//         percentage: "80",
//       },
//       {
//         skillName: "TensorFlow",
//         percentage: "70",
//       },
//       {
//         skillName: "Keras",
//         percentage: "65",
//       },
//       {
//         skillName: "PyTorch",
//         percentage: "60",
//       },
//     ],
//   },
//   // {
//   //   label: "Business Intelligence",
//   //   data: [
//   //     {
//   //       skillName: "Power BI",
//   //       percentage: "75",
//   //     },
//   //     {
//   //       skillName: "Tableau",
//   //       percentage: "70",
//   //     },
//   //   ],
//   // },
//   {
//     label: "Advanced Data Analytics",
//     data: [
//       {
//         skillName: "Power BI Advanced Analytics",
//         percentage: "80",
//       },
//     ],
//   },
//   {
//     label: "Programming Languages",
//     data: [
//       {
//         skillName: "C",
//         percentage: "85",
//       },
//       {
//         skillName: "C++",
//         percentage: "80",
//       },
//     ],
//   },
// ];
export const skillsData = [
  {
    label: "Programming Languages",
    data: [
      { skillName: "C++" },
      { skillName: "Python" },
      { skillName: "SQL" },
    ],
  },
  {
    label: "Front-end Development",
    data: [
      { skillName: "React JS" },
      { skillName: "HTML" },
      { skillName: "CSS" },
      { skillName: "Tailwind CSS" },
    ],
  },
  {
    label: "Backend Development",
    data: [
      { skillName: "Node JS" },
      { skillName: "Express JS" },
      { skillName: "MongoDB" },
      { skillName: "Mongoose" },
      { skillName: "REST APIs" },
    ],
  },
  {
    label: "Machine Learning",
    data: [
      { skillName: "PyTorch" },
      { skillName: "TensorFlow" },
      { skillName: "Computer Vision" },
      { skillName: "YOLOv8" },
      { skillName: "Faster R-CNN" },
    ],
  },
];
